import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useAccess } from '../lib/access';

// "Assigned to" for tasks and jobs: crew and managers with access to the property, from
// assignable_people(property). Shown only to people who can edit work on that property.
export default function AssigneePicker({ propertyId, value, onChange }) {
  const access = useAccess();
  const [people, setPeople] = useState([]);
  const allowed = !!propertyId && access.can(propertyId, 'edit');

  useEffect(() => {
    let cancelled = false;
    if (!allowed) { setPeople([]); return; }
    supabase.rpc('assignable_people', { p_property: propertyId }).then(({ data }) => {
      if (!cancelled) setPeople(data || []);
    });
    return () => { cancelled = true; };
  }, [propertyId, allowed]);

  if (!allowed) return null;

  // Keep a current assignee who no longer has access visible, so saving doesn't silently drop them.
  const options = value && !people.some(p => p.email === value)
    ? [...people, { email: value, display_name: null, role: 'no access' }]
    : people;

  return (
    <div className="form-group">
      <label>Assigned to</label>
      <select value={value || ''} onChange={e => onChange(e.target.value || null)} data-field="assigned_to">
        <option value="">Unassigned</option>
        {options.map(p => (
          <option key={p.email} value={p.email}>
            {p.display_name ? `${p.display_name} (${p.email})` : p.email} — {p.role}
          </option>
        ))}
      </select>
    </div>
  );
}
